import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router'

// https://stackoverflow.com/a/41995695
// CustomUrlSerializer нужен для компоненты bmcore-producer-page-header,
// а конкретнее для кнопки обмена сообщений.
// по умолчанию Angular использует encoding и превращает 'messages#3' в 'messages%233'
// т.е. превращает # в %23
export class CustomUrlSerializer implements UrlSerializer {
  parse(url: string): UrlTree {
    let dus = new DefaultUrlSerializer()
    return dus.parse(url)
  }

  serialize(tree: UrlTree): string {
    let dus = new DefaultUrlSerializer(),
      path = dus.serialize(tree)
    // Заменяем %23 на #
    path = path.replace(/%23/g, '#')
    // Заменяем %3F на ?
    path = path.replace(/%3F/g, '?')
    // Заменяем %3D на =
    path = path.replace(/%3D/g, '=')
    // Заменяем %26 на &
    path = path.replace(/%26/g, '&')
    return path
  }
}
